import React from 'react';
import share from 'Services/share';
import shareConfig from 'Config/shareConfig';

const TopShareButtons = () => (
  <div className="share">
    <a
      className="facebook"
      href={share('facebook', window.location.href)}
      target="_blank"
      rel="noopener noreferrer"
    >
    Facebook
    </a>
    <a
      className="twitter"
      href={share(
        'twitter',
        window.location.href,
        shareConfig.text,
        shareConfig.twitter.via,
        shareConfig.twitter.hashtags
      )}
      target="_blank"
      rel="noopener noreferrer"
    >
    Twitter
    </a>
    <a
      className="linkedin"
      href={share(
        'linkedin',
        window.location.href,
        shareConfig.title,
        shareConfig.summary,
        shareConfig.source
      )}
      target="_blank"
      rel="noopener noreferrer"
    >
    LinkedIn
    </a>
    <a
      className="email"
      href={share('email', window.location.href, shareConfig.title)}
    >
    Email
    </a>
  </div>
);

export default TopShareButtons;



// WEBPACK FOOTER //
// ./app/components/topShareButtons/index.js